<div class="container-cards">
  <div class="container-ghost">
    <div class="card-container-shadow padding-md border-radius-sm" [ngStyle]="cardStyles">
      <div class="title text-subtitle-bold-upper">
        <p>ÚLTIMA CITA</p>
        <img loading="lazy" src="./../../../assets/images/icons/icons8-time-limit-100.png" alt="">
      </div>
      <div class="strong-text text-title-lg">
        <p>{{ appointmentData.startDate.date | date }}</p>
      </div>
      <div class="text-info">
        <p>
          {{ appointmentData?.startDate.hour > 12 ? appointmentData?.startDate.hour - 12 : appointmentData?.startDate.hour}}:{{
          appointmentData?.startDate.minute === 0 ? '00' : appointmentData.startDate.minute }}
          {{ appointmentData?.startDate.hour >= 12 ? ' PM' : ' AM' }}
          {{' (' + appointmentData?.minutes + ' min)'}}
        </p>
      </div>
    </div>
  </div>
  <div class="container-ghost">
    <div class="card-container-shadow padding-md border-radius-sm" [ngStyle]="cardStyles">
      <div class="title text-subtitle-bold-upper">
        <p>CITAS TOTALES</p>
        <img loading="lazy" src="./../../../assets/images/icons/icons8-planner-100.png" alt="">
      </div>
      <div class="strong-text text-title-lg">
        <p>{{ totalAppointments }}</p>
      </div>
      <div class="text-info">
        <p>Servicio activo</p>
      </div>
    </div>
  </div>
  <div class="container-ghost">
    <div class="card-container-shadow padding-md border-radius-sm" [ngStyle]="cardStyles">
      <div class="title text-subtitle-bold-upper">
        <p>TIPO DE SERVICIO</p>
        <img loading="lazy" src="./../../../assets/images/icons/icons8-rod-of-asclepius-100.png" alt="">
      </div>
      <div class="strong-text text-title-lg">
        <p>{{ appointmentData?.type | getTranslateEnum :'appointmentType' }}</p>
      </div>
      <div class="text-info">
        <p>Clínica buena vista</p>
      </div>
    </div>
  </div>
  <div class="container-ghost">
    <div class="card-container-shadow padding-md border-radius-sm" [ngStyle]="cardStyles">
      <div class="title text-subtitle-bold-upper">
        <p>INTEGRANTES</p>
        <img loading="lazy" src="./../../../assets/images/icons/icons8-user-groups-skin-type-7-100.png" alt="">
      </div>
      <div class="strong-text">
        <app-avatar-group [users]="appointmentData?.users"></app-avatar-group>
      </div>
      <div class="text-info">
        <p>{{ appointmentData?.users.length }} Persona{{appointmentData?.users.length > 1 ? 's' : ''}}</p>
      </div>
    </div>
  </div>
</div>
